import { useState } from "react";
import { toast } from "sonner";
import { Download, FileSpreadsheet, Loader2, Upload } from "lucide-react";
import { API, apiForm } from "@/lib/api";

// Khusus Admin PPID: tambah banyak Agenda Kegiatan sekaligus lewat Excel.
export default function AgendaImport({ onDone }) {
  const [busy, setBusy] = useState(false);
  const [errText, setErrText] = useState("");

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    setErrText("");
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await apiForm("/api/admin/agenda/import", fd);
      const rincian = Object.entries(res.perGroup || {})
        .map(([k, n]) => `${k}: ${n}`)
        .join(", ");
      toast.success(
        `${res.inserted} kegiatan ditambahkan dari Excel${rincian ? ` (${rincian})` : ""}`
      );
      await onDone?.();
    } catch (e) {
      setErrText(e.message);
      toast.error("Unggahan Excel ditolak — periksa rincian kesalahan.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="agenda-import-panel"
      className="mt-8 rounded-3xl border border-dashed border-[#BBDCF3] bg-[#FBFDFF] p-6 md:p-8"
    >
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="min-w-0">
          <h2 className="flex items-center gap-2 font-display text-xl font-semibold text-[#0B2440]">
            <FileSpreadsheet aria-hidden="true" className="h-5 w-5 text-[#1479BF]" />
            Unggah Excel
          </h2>
          <p className="mt-2 max-w-xl text-xs leading-relaxed text-slate-500">
            Tambah banyak kegiatan sekaligus. Unduh template, isi sesuai kolom
            (Penanggungjawab & Realisasi berupa pilihan dropdown di Excel), lalu
            unggah kembali. Kegiatan otomatis masuk ke bagian sesuai
            Penanggungjawab yang dipilih.
          </p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <a
            data-testid="agenda-template-download"
            href={`${API}/api/admin/agenda/template.xlsx`}
            className="inline-flex items-center gap-1.5 rounded-full border border-[#1479BF] px-4 py-2 text-[11px] font-bold text-[#1479BF] transition-colors duration-300 hover:bg-[#EFF6FC]"
          >
            <Download aria-hidden="true" className="h-3.5 w-3.5" />
            Unduh Template
          </a>
          <label
            className={`inline-flex items-center gap-1.5 rounded-full px-4 py-2 text-[11px] font-bold text-white transition-colors duration-300 ${
              busy ? "bg-[#1479BF]/70" : "cursor-pointer bg-[#1479BF] hover:bg-[#0B2440]"
            }`}
          >
            {busy ? (
              <Loader2 aria-hidden="true" className="h-3.5 w-3.5 animate-spin" />
            ) : (
              <Upload aria-hidden="true" className="h-3.5 w-3.5" />
            )}
            {busy ? "Mengunggah..." : "Unggah Excel"}
            <input
              type="file"
              hidden
              accept=".xlsx"
              disabled={busy}
              data-testid="agenda-import-input"
              onChange={(e) => {
                upload(e.target.files[0]);
                e.target.value = "";
              }}
            />
          </label>
        </div>
      </div>
      {errText && (
        <pre
          data-testid="agenda-import-errors"
          className="mt-4 whitespace-pre-wrap rounded-xl bg-red-50 px-4 py-3 font-sans text-[11px] leading-relaxed text-red-600"
        >
          {errText}
        </pre>
      )}
    </div>
  );
}
